





































































































































































import { CreateElement, VNode, VNodeDirective } from 'vue';
import { Component, Prop, Model, Watch, Provide } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwIcon } from '../sw-icon';
import { CSSStyleOptions, DimensionRect } from '../common-types';
import { ProvidedModalParam } from './types';
import { utilService } from '../util-service';
import { domService } from '../dom-service';
import { drag, DragDirValues } from '../drag-dir';

const cssPrefix = 'sw-modal';

/**
 * Events:
 * @event request-close `(open: false)`
 */
@Component({
  components: {
    SwIcon,
  },
  directives: {
    drag,
  },
})
export default class SwModal extends SwExtendedVue {
  @Prop({ type: String, default: 'regular' })
  mode: ProvidedModalParam['mode'];

  @Prop({ type: String, required: true })
  title: string;

  @Model('request-close', { type: Boolean, default: false })
  visible: boolean;

  @Prop({ type: Boolean, default: true })
  closable: boolean;

  @Prop({ type: Boolean, default: true })
  draggable: boolean;

  @Prop({ type: [String, Number], default: '80%' })
  width: string | number;

  @Prop({ type: [String, Number], default: '100%' })
  maxWidth: string | number;

  @Prop({ type: Boolean, default: true })
  vShowEnabled: boolean;

  @Prop({ type: Object, default: null })
  overlayDimension: DimensionRect | null;

  @Prop({ type: Boolean, default: true })
  centerToOverlay: boolean;

  @Provide()
  modalParam: ProvidedModalParam = {
    mode: this.mode,
  };

  cssPrefix = cssPrefix;

  rootVisible: boolean = this.visible;
  bodyStyleTicket: string = '';

  visibleDimension: DimensionRect | null = null;

  get effectiveDraggable() {
    return this.draggable && this.mode !== 'pillar';
  }

  get rootStyle(): CSSStyleOptions {
    const style: CSSStyleOptions = {};

    if (this.overlayDimension) {
      style.top = `${this.overlayDimension.top}px`;
      style.left = `${this.overlayDimension.left}px`;
      style.width = `${this.overlayDimension.width}px`;
      style.height = `${this.overlayDimension.height}px`;
    }
    return style;
  }

  get contentStyle(): CSSStyleOptions {
    const style: CSSStyleOptions = {
      width: typeof this.width === 'number' ? `${this.width}px` : this.width,
      maxWidth: typeof this.maxWidth === 'number' ? `${this.maxWidth}px` : this.maxWidth,
    };

    if (this.visibleDimension) {
      style.top = `${this.visibleDimension.top}px`;
      style.left = `${this.visibleDimension.left}px`;
    }
    return style;
  }

  get animationName(): string {
    return this.mode === 'pillar' ? 'sw-modal-fold' : 'sw-modal-slide';
  }

  get dragDirValues(): DragDirValues | null {
    if (!this.effectiveDraggable) { return null; }
    return {
      start: () => {
      },
      positioning: (toClientPos) => {
        if (!this.visibleDimension) { return; }
        this.visibleDimension.top = toClientPos.y;
        this.visibleDimension.left = toClientPos.x;
        if (this.mode === 'regular-light') {
          this.visibleDimension.top -= 1;
          this.visibleDimension.left -= 1;
        }
        this.adjustVisibleDimension(false);
      },
      done: (toClientPos) => {
        /**
         * adjust the content pos so that it won't get into the situation
         * where it is no longer accessible after dragging.
         */
        if (!this.visibleDimension) { return; }
        this.visibleDimension.top = toClientPos.y;
        this.visibleDimension.left = toClientPos.x;
        if (this.mode === 'regular-light') {
          this.visibleDimension.top -= 1;
          this.visibleDimension.left -= 1;
        }
        this.adjustVisibleDimension(true);
      },
    };
  }

  @Watch('mode')
  private syncMode(val: ProvidedModalParam['mode']) {
    this.modalParam.mode = val;
  }

  @Watch('visible', { immediate: true })
  private onVisibleChanged(val: boolean) {
    if (val) {
      this.rootVisible = true;
      this.$nextTick(() => {
        if (this.$refs.content) {
          domService.resizeObserver.on(this.$refs.content as HTMLElement, this.onContentResize);
        }
      });
    } else {
      if (this.$refs.content) {
        domService.resizeObserver.off(this.$refs.content as HTMLElement, this.onContentResize);
      }
    }
  }

  @Watch('rootVisible')
  private onRootVisibleChange() {
    if (this.rootVisible) {
      this.cancelCurrentBodyStyle();
      this.bodyStyleTicket = domService.stylesManager.apply(document.body, { overflowX: 'hidden', overflowY: 'hidden' });
    } else {
      this.cancelCurrentBodyStyle();
    }
    this.$nextTick(() => {
      this.updateVisibleDimension();
    });
  }

  public recenter() {
    this.updateVisibleDimension();
  }

  /** this is for re-center the modal */
  private updateVisibleDimension() {
    const contentEl: HTMLElement = this.$refs.content as HTMLElement;
    if (!contentEl || !this.rootVisible) {
      this.visibleDimension = null;
      return;
    }
    const vpWidth = this.centerToOverlay && this.overlayDimension ? this.overlayDimension.width : window.innerWidth;
    const vpHeight = this.centerToOverlay && this.overlayDimension ? this.overlayDimension.height : window.innerHeight;
    const width = contentEl.scrollWidth;
    const height = contentEl.scrollHeight;
    let top = (vpHeight - height) / 2;
    let left = (vpWidth - width) / 2;
    if (this.centerToOverlay && this.overlayDimension) {
      top += this.overlayDimension.top;
      left += this.overlayDimension.left;
    }
    this.visibleDimension = { top, left, width, height };
    this.adjustVisibleDimension(true);
  }

  private adjustVisibleDimension(isFinal: boolean) {
    /** adjust per display mode due to the offset from __header to __content */
    if (!this.visibleDimension) { return; }
    if (isFinal) {
      if (this.visibleDimension.top < 0) { this.visibleDimension.top = 0; }
      if (this.visibleDimension.left < 0) { this.visibleDimension.left = 0; }
      if (this.visibleDimension.top > window.innerHeight) { this.visibleDimension.top = window.innerHeight - 20; }
      if (this.visibleDimension.left > window.innerWidth) { this.visibleDimension.left = window.innerWidth - 20; }
    }
  }

  private closeModal () {
    this.$emit('request-close', false);
  }

  private afterContentLeave() {
    this.rootVisible = false;
  }

  private cancelCurrentBodyStyle() {
    if (!!this.bodyStyleTicket) {
      domService.stylesManager.cancel(document.body, this.bodyStyleTicket);
      this.bodyStyleTicket = '';
    }
  }

  private onContentResize() {
    if (!this.visibleDimension) { return; }
    const contentEl: HTMLElement = this.$refs.content as HTMLElement;
    /** if the bottom of the content goes off the screen, we pull it up automatically */
    const rect = contentEl.getBoundingClientRect();
    const bottom = rect.top + rect.height;
    const vpHeight = window.innerHeight;
    if (bottom > vpHeight) {
      const delta = bottom - vpHeight;
      this.visibleDimension.top = this.visibleDimension.top - delta;
    }
  }

  private mounted() {
    this.$nextTick(() => {
      this.updateVisibleDimension();
    });
  }

  private beforeDestroy() {
    if (!!this.bodyStyleTicket) {
      domService.stylesManager.cancel(document.body, this.bodyStyleTicket);
      this.bodyStyleTicket = '';
    }
    if (this.$refs.content) {
      domService.resizeObserver.off(this.$refs.content as HTMLElement, this.onContentResize);
    }
  }

  private render(h: CreateElement): VNode {// tslint:disable-line
    let closeNode: VNode | null = null;
    const contentNodes: VNode[] = [];

    if (this.closable) {
      closeNode = (
        <span class={[`${this.cssPrefix}__close-cont`, 'sw-flexbox__flex-none']}>
          <span
            class={[
              `${this.cssPrefix}__close`,
              'sw-flexbox', 'sw-flexbox--center-items', 'sw-flexbox--center-justify',
            ]}
            onClick={ this.closeModal }
            onMousedown={(event: MouseEvent) => { event.stopPropagation(); }}
          >
            <sw-icon name="close-thin" size={13}></sw-icon>
          </span>
        </span>
      ) as VNode;
    }

    if (this.visible || this.vShowEnabled) {
      const directives: Partial<VNodeDirective>[] = [];
      const headerDirectives: Partial<VNodeDirective>[] = [];
      if (this.vShowEnabled) {
        directives.push({ name: 'show', value: this.visible });
      }
      if (this.dragDirValues) {
        headerDirectives.push({ name: 'drag', value: this.dragDirValues });
      }

      contentNodes.push(
        <div
          class={[`${this.cssPrefix}__content`, 'sw-flexbox', 'sw-flexbox--column']}
          style={ this.contentStyle }
          {...{ directives }}
          ref="content"
        >
          <div
            class={[
              `${this.cssPrefix}__header`,
              { [`${this.cssPrefix}__header--draggable`]: this.effectiveDraggable },
              'sw-flexbox__flex-none',
              'sw-flexbox', 'sw-flexbox--center-items',
            ]}
            {...{ directives: headerDirectives }}
          >
            <span class={[`${this.cssPrefix}__title`, 'sw-flexbox__flex']}>{this.title}</span>
            {closeNode}
          </div>
          <div class={[`${this.cssPrefix}__main-body`, 'sw-flexbox__flex', 'sw-flexbox', 'sw-flexbox--column']}>
            {utilService.getVueScopedSlot(this.$scopedSlots)}
          </div>
        </div> as VNode,
      );
    }

    const rootNode = (
      <div class={[`${this.cssPrefix}`, `${this.cssPrefix}--${this.mode}`, 'sw-typo-default']}
        v-show={this.rootVisible}
        style={this.rootStyle}
      >
        <transition
          name={this.animationName}
          onAfterLeave={this.afterContentLeave}
        >
          {contentNodes}
        </transition>
      </div>
    );

    return rootNode as VNode;
  }
}
